import client from 'api/apiClient';
import { EventStatuses, GetEventListPayload } from 'types/baskets';
import { EventStatus } from 'types/common';

interface GetBasketsDataPayload {
    status: EventStatus;
    subType?: string | undefined | null;
    companyId: number;
    headers?: object;
    name?: string;
}

export const getBasketData = async (props: GetBasketsDataPayload) => {
    const { status, subType, companyId, headers, name } = props || {};
    let eventStatuses: EventStatuses[] = [];
    let payload: GetEventListPayload = {
        companyId,
    };
    if (status) {
        eventStatuses = Array.isArray(status) ? status : [status];
        if (eventStatuses?.length) {
            payload.eventStatuses = eventStatuses;
        }
    }
    if (subType) {
        payload.subType = subType;
    }
    if (name) {
        payload.name = name;
    }
    try {
        const response = await client.post('/events/list/getEventList', payload, {
            criteria: 2,
            sortCriteria: 1,
            ...headers,
        });
        const data: any = response;
        return data;
    } catch (error) {
        console.error('Error getting data:', error);
        throw error || new Error('An unknown error occurred.');
    }
};
